/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation createHookActionMutation($record: EntityCreateInput!) {
        result: createEntity(record: $record) {
            id
        }
    }
`;
